import axios from 'axios';
import { useMutation, queryCache } from 'react-query';
import { backendURL } from '../App';

export async function importQuestionsExcel(anketaId: number, file: File) {
  const data = new FormData();
  data.append('file', file);
  data.append('anketa_id', String(anketaId));
  const res = await axios({
    method: 'post',
    url: `${backendURL}questions/import/`,
    headers: {
      Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return res.data;
}

export default function useImportQuestionsExcelMutation(anketaID: string) {
  return useMutation((file: File) => importQuestionsExcel(Number(anketaID), file), {
    onSuccess: () => {
      queryCache.invalidateQueries(['anketaQuestionsData', anketaID]);
    },
  });
}
